import {LicenseInfo} from '@mui/x-license';

export const MUI_PRO_LICENSE_KEY =
  '93ec0c2d73b437e9b74e015ffbab689cTz0xMzEwNzMsRT0xODE1NjA5NTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1pbml0aWFsLEtWPTI=';
LicenseInfo.setLicenseKey(MUI_PRO_LICENSE_KEY);
